import { ChipWrapper } from './Chip.styled';
import { ChipProperties } from './Chip.types';

export const Chip = ({ tint, text }: ChipProperties) => {
    if (!text || text.length === 0) {
        return null;
    }
    return <ChipWrapper $tint={tint}>{text}</ChipWrapper>;
};
